import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ResetPasswordPage = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error('Password must be at least 8 characters');
    if (password !== confirm) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/reset-password', { token, new_password: password });
      toast.success(data.message || 'Password updated');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--cr-primary)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px 20px' }}>
        <h1 style={{ color: 'white', fontSize: '24px', fontWeight: '700' }}>Connected Rider</h1>
      </div>

      <div style={{ background: 'white', borderRadius: '24px 24px 0 0', padding: '28px 24px 40px' }}>
        {!token ? (
          <>
            <h2 style={{ marginBottom: '12px', textAlign: 'center' }}>Link not valid</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '24px' }}>
              This reset link is missing its code. Please request a new one.
            </p>
            <Link to="/forgot-password" className="btn btn-primary btn-full btn-lg" style={{ textDecoration: 'none', display: 'block', textAlign: 'center' }}>
              Request a new link
            </Link>
          </>
        ) : (
          <>
            <h2 style={{ marginBottom: '8px', textAlign: 'center' }}>Choose a new password</h2>
            <p style={{ fontSize: '14px', color: 'var(--text-secondary)', textAlign: 'center', marginBottom: '20px' }}>
              At least 8 characters.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">New password</label>
                <input className="form-input" type="password" placeholder="New password"
                  value={password} onChange={e => setPassword(e.target.value)} required autoFocus />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm new password</label>
                <input className="form-input" type="password" placeholder="Repeat it"
                  value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>
              <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: '8px' }}>
                {loading ? 'Saving...' : 'Save new password'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: '20px', fontSize: '14px' }}>
              <Link to="/login" style={{ color: 'var(--cr-primary)', fontWeight: '500', textDecoration: 'none' }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
